import Button from '@carvana/ds-button';
import { heading, text, spacing, borderRadius, body, breakpoint } from '@carvana/ds-styles';
import styled from 'styled-components';

const Wrapper = styled.div`
  justify-self: center;
  align-self: center;
  width: 100%;
`;

const StyledButton = styled(Button)`
  &.where-is-my-vin {
    width: 100%;
  }
`;

const Heading = styled.div`
  ${heading.xl};
  color: ${text.strong};
  margin-bottom: ${spacing['2Xl']};

  @media screen and (max-width: ${breakpoint.sm}) {
    ${heading.md};
  }
`;

const Part = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing['2Xl']};
  gap: ${spacing.lg};

  img,
  picture {
    border-radius: ${borderRadius.md};
    width: 192px;
    height: auto;
    flex-shrink: 0;
  }

  picture img {
    width: 100%;
    height: auto;
  }

  @media screen and (max-width: ${breakpoint.sm}) {
    flex-direction: column;
    gap: ${spacing['3Xl']};
    margin-bottom: ${spacing.xl};

    img,
    picture {
      width: 100%;
    }
  }
`;

const Caption = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: ${breakpoint.sm}) {
    padding: 0;
  }
`;

const Text = styled.div`
  ${heading.md};
  color: ${text.strong};
  margin-bottom: ${spacing.md};

  @media screen and (max-width: ${breakpoint.sm}) {
    ${heading.sm};
    margin-bottom: ${spacing.sm};
  }
`;

const SubText = styled.div`
  ${body.regular.sm};
  color: ${text.default};
`;

const OtherSourcesSection = styled.div`
  width: 100%;
  margin-bottom: ${spacing['2Xl']};
`;

const OtherSourcesHeading = styled.div`
  ${heading.md};
  color: ${text.strong};
  margin-bottom: ${spacing.lg};

  @media screen and (max-width: ${breakpoint.sm}) {
    ${heading.sm};
  }
`;

const SourceList = styled.ul`
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.sm};
  align-self: stretch;
  list-style: none;
  margin: 0;
`;

const SourceItem = styled.li`
  display: list-item;
  list-style-position: outside;
  list-style-type: disc;
  margin-left: ${spacing.lg};
  margin-bottom: ${spacing.md};
  ${body.regular.sm};
  color: ${text.default};

  &:last-child {
    margin-bottom: 0;
  }
`;

const SourceTitle = styled.span`
  font-weight: 600;
  color: ${text.strong};
`;

const SourceDescription = styled.span`
  color: ${text.default};
`;

export {
  Wrapper,
  StyledButton,
  Heading,
  Part,
  Text,
  SubText,
  Caption,
  OtherSourcesSection,
  OtherSourcesHeading,
  SourceList,
  SourceItem,
  SourceTitle,
  SourceDescription
};
